import QNotification from './src/QNotification.js';

export default QNotification;
